import Vuex, { StoreOptions } from 'vuex';
import { account } from './modules/account/index';
import { RootState } from './types';
import { entityNames } from './modules/entityNames/index';
import { orders } from './modules/orders/index';
import { pharmacy } from './modules/pharmacy/index';
import { users } from './modules/users/index';
import { roles } from './modules/roles/index';

const store: StoreOptions<RootState> = {
  state: {
    welcomeMessage: 'Hello'
  },
  mutations: {},
  actions: {},
  modules: {
    account,
    entityNames,
    orders,
    pharmacy,
    users,
    roles
  }
};

export default new Vuex.Store<RootState>(store);
